import { render, staticRenderFns } from "./LoadingAsset.vue?vue&type=template&id=f79855b2&scoped=true"
import script from "./LoadingAsset.vue?vue&type=script&lang=js"
export * from "./LoadingAsset.vue?vue&type=script&lang=js"
import style0 from "./LoadingAsset.vue?vue&type=style&index=0&id=f79855b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79855b2",
  null
  
)

export default component.exports